import { render, staticRenderFns } from "./KennelRegistrationCard.vue?vue&type=template&id=bd54fe22"
import script from "./KennelRegistrationCard.vue?vue&type=script&lang=ts"
export * from "./KennelRegistrationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports